/* Injects Judge.me's own native star markup (same jdgm-star icon font already
   used by the preview badge elsewhere on the page, so styling/color/boldness
   matches automatically) above the "Be the first..." text, and fixes button
   text capitalization in a couple of spots where the desired capitalization
   isn't achievable with a simple CSS text-transform (e.g. "Leave a Review"
   needs only "Review" capitalized, not "a" too). Judge.me's content loads
   asynchronously, so we use a MutationObserver rather than a single
   DOMContentLoaded pass. */
(function () {
  function starsHTML() {
    return '<span class="jdgm-star jdgm--off"></span>'.repeat(5);
  }

  function process() {
    document.querySelectorAll('.jm-no-reviews-state__text:not([data-gladleys-processed])').forEach(function (textEl) {
      textEl.setAttribute('data-gladleys-processed', '1');

      var wrapper = document.createElement('div');
      wrapper.className = 'gladleys-summary-block';

      var starRow = document.createElement('div');
      starRow.className = 'gladleys-star-row';
      starRow.innerHTML = starsHTML();

      textEl.parentNode.insertBefore(wrapper, textEl);
      wrapper.appendChild(starRow);
      wrapper.appendChild(textEl);
    });

    document.querySelectorAll('.jm-action-buttons__button').forEach(function (btn) {
      if (btn.textContent.trim() === 'Write a review') {
        btn.textContent = 'Write a Review';
      }
    });

    document.querySelectorAll('.jdgm-write-review-modal__btn--leave-review').forEach(function (btn) {
      if (btn.textContent.trim() === 'Leave a review') {
        btn.textContent = 'Leave a Review';
      }
    });
  }

  process();
  var observer = new MutationObserver(process);
  observer.observe(document.body, { childList: true, subtree: true });
})();
